/**
 * Created by mukund on 8/24/17.
 */

angular.module('mediacloudApp')
    .directive('uploadError', function(){
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'scripts/components/upload/directives/error/error.html',
            scope: {
                errors: '=',
                isMetaError: '='
            }
        }
    });
